import React from 'react';
import { modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-194" data-mp="100c9f2m1l0zr">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-195" data-mp="zy97plbj1jf7">
        <header className="mx-auto max-w-narrow text-center" data-id="element-196" data-mp="l4mq5c88r1yq">
          <h2 className="font-display text-[2rem] font-extrabold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-197" data-mp="q1we0nfzf5kg">
            Sistema Completo:
            <br data-id="element-198" data-mp="1dsse07uld72s" />
            <span className="text-blue-600" data-id="element-199" data-mp="1ducyf4n6z9mx">50 Mapas Visuales</span>
          </h2>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-200" data-mp="1isxzt7e6jzcy">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-soft ring-1 ring-blue-100" data-id="element-201" data-mp="191aapd53iuen">
              <div className="flex items-baseline gap-3" data-id="element-202" data-mp="1wpjr1zjjipye">
                <span className="font-display text-5xl font-extrabold leading-none tracking-tight text-petrol" data-id="element-203" data-mp="21huxll8sd9zx">
                  {module.count}
                </span>
                <span className="font-display text-sm font-extrabold uppercase tracking-[0.12em] text-petrol/80" data-id="element-204" data-mp="2qgqz6whq5jgw">
                  mapas
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl font-extrabold tracking-tight text-ink" data-id="element-205" data-mp="357q49xjcppvq">
                {module.title}
              </h3>
              <p className="mt-2 text-blue-900/75" data-id="element-206" data-mp="3e5inhcs71hoe">{module.summary}</p>
              <p className="mt-auto pt-4 font-semibold text-blue-700" data-id="element-207" data-mp="3978p6tb6a0yk">{module.closing}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}